import "./../App.css"
import { useState } from "react"
import Header from "../components/Header"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"

import { Outlet, Link } from "react-router-dom"

const tab_items = [
	{ name: "Conceptos", url: "conceptos" },
	{ name: "Equipamiento", url: "equipamiento" },
	{ name: "Como jugar", url: "howto" },
	{ name: "Selección", url: "seleccion" },
	{ name: "El Taller", url: "taller" },
	{ name: "Hockey por el mundo", url: "world" },
]
function InfoPage() {
	const [tab_value, setValue] = useState(0)

	const handleChange = (event, newValue) => {
		setValue(newValue)
	}
	return (
		<div className="content">
			<Header title="Sobre nosotros" />

			<Tabs
				// disable the tab indicator because it doesn't work well with wrapped container
				TabIndicatorProps={{ sx: { display: "none" } }}
				sx={{
					"& .MuiTabs-flexContainer": {
						flexWrap: "wrap",
					},
				}}
				value={tab_value}
				onChange={handleChange}
				centered
			>
				{tab_items.map((tab, i) => (
					<Tab key={i} label={tab.name} component={Link} to={tab.url} />
				))}
			</Tabs>
			<br></br>

			<Outlet />
		</div>
	)
}

export default InfoPage
